import { render, staticRenderFns } from "./GroupNotesRightBar.vue?vue&type=template&id=40312126&"
import script from "./GroupNotesRightBar.vue?vue&type=script&lang=js&"
export * from "./GroupNotesRightBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupNotesRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports